//TODO: breakpoints depending on portal
export const mediaBreakpoints = {
  sm: '768px',
  md: '992px',
  lg: '1400px'
}

export const mediaBreakpointsAsNumber = {
  sm: 768,
  md: 992,
  lg: 1400
}

export const FilterPageUrl = '/search-accommodations'

export const OccupancyLocalStorage: string = 'occupancy'

export const CartLocalStorage: string = 'cart'

export const FiltersLocalStorage: string = 'filters'

export const VersionLocalStorage: string = 'versionpui'

export const RequestedCidsLocalStorage: string = 'requestedcids'

export const ValidLanguages: Array<string> = ['de', 'it', 'en', 'fr', 'pl', 'nl']

export const GdsCookie: string = 'gds'

export const PetsAllowedAmenityId: number = 174

export const FilterPageName: string = 'filterpage'

export const AccosBarName: string = 'accosbar'

export const EnquiryBarName: string = 'enquirybar'

export const EnquiryBoxName: string = 'enquirybox'

export const EnquiryPageName: string = 'enquirypage'
